import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { onlyDigits } from "../../services/valid";
import { StatusHse, DocumentosHse, dataHse, arquivoDocumento } from "./statusHse";

export const Colaboradores = () => {
  const [colaboradores, setColaboradores] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [busca, setBusca] = useState("");
  const [empresaId, setEmpresaId] = useState("");
  const [status, setStatus] = useState("");
  const [aberto, setAberto] = useState(null);
  const [enviados, setEnviados] = useState([]);

  const getDados = async () => {
    try {
      const [col, emp] = await Promise.all([
        blogFetch.get("/sga/collaborator"),
        blogFetch.get("/sga/company"),
      ]);
      setColaboradores(col.data);
      setEmpresas(emp.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getDados();
  }, []);

  const termo = busca.toLowerCase();
  const digitos = onlyDigits(busca);
  const filtrados = colaboradores.filter(
    (c) =>
      (!termo ||
        c.nome?.toLowerCase().includes(termo) ||
        c.matricula?.toLowerCase().includes(termo) ||
        c.empresa?.toLowerCase().includes(termo) ||
        (digitos.length >= 3 && onlyDigits(c.cpf).includes(digitos))) &&
      (!empresaId || c.empresaId === Number(empresaId)) &&
      (!status || c.status === status)
  );

  const abrir = async (c) => {
    if (aberto === c.id) {
      setAberto(null);
      return;
    }
    setAberto(c.id);
    setEnviados([]);
    try {
      const res = await blogFetch.get("/sga/document", { params: { colaboradorId: c.id } });
      setEnviados(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const baixar = async (doc) => {
    try {
      await arquivoDocumento(doc, true);
    } catch (err) {
      toast.error("Não foi possível baixar o documento.");
    }
  };

  const alternarAtivo = async (c) => {
    try {
      await blogFetch.put(`/sga/collaborator/${c.id}/active`, { ativo: !c.ativo });
      await getDados();
      toast.success(`${c.nome} ${c.ativo ? "inativado" : "reativado"}.`);
    } catch (err) {
      toast.error("Erro ao alterar o colaborador.");
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <div className="d-flex align-items-center mb-4">
          <h3 className="fw-bold text-center mb-0 flex-grow-1">Colaboradores Terceiros</h3>
          <Button as={Link} to="/hse/cadastro">+ Cadastrar terceiro</Button>
        </div>

        <Row className="g-3 mb-4">
          <Col md={4}>
            <Form.Control
              type="search"
              placeholder="Buscar nome, CPF, matrícula ou empresa"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Select value={empresaId} onChange={(e) => setEmpresaId(e.target.value)}>
              <option value="">Todas as empresas</option>
              {empresas.map((e) => (
                <option key={e.id} value={e.id}>{e.nomeFantasia}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={2}>
            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">Todos os status</option>
              {["Liberado", "Pendente", "Bloqueado"].map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <div className="table-responsive" style={{ maxHeight: "650px" }}>
          <Table bordered hover className="align-middle text-center" style={{ minWidth: "1000px" }}>
            <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
              <tr>
                {["Nome", "CPF", "Matrícula", "Empresa", "Função", "Status", "Ações"].map((c) => (
                  <th key={c} className="text-nowrap">{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length ? (
                filtrados.map((c) => (
                  <Fragment key={c.id}>
                    <tr style={{ cursor: "pointer" }} onClick={() => abrir(c)}>
                      <td className="text-start">{aberto === c.id ? "▾" : "▸"} {c.nome}</td>
                      <td className="text-nowrap">{c.cpf}</td>
                      <td>{c.matricula || "-"}</td>
                      <td>{c.empresa}</td>
                      <td>{c.funcao}</td>
                      <td><StatusHse status={c.status} /></td>
                      <td>
                        <Button
                          size="sm"
                          variant={c.ativo ? "outline-secondary" : "outline-success"}
                          onClick={(e) => {
                            e.stopPropagation();
                            alternarAtivo(c);
                          }}
                        >
                          {c.ativo ? "Inativar" : "Reativar"}
                        </Button>
                      </td>
                    </tr>
                    {aberto === c.id && (
                      <tr>
                        <td colSpan={7} className="bg-light">
                          <Row className="g-3 text-start p-2">
                            <Col md={5}>
                              <div className="fw-bold mb-2">Motivos do status</div>
                              {c.motivos?.length ? (
                                <ul className="mb-0">
                                  {c.motivos.map((m) => <li key={m}>{m}</li>)}
                                </ul>
                              ) : (
                                <div className="text-success">Toda a documentação está em dia.</div>
                              )}
                            </Col>
                            <Col md={7}>
                              <div className="fw-bold mb-2">Documentos obrigatórios</div>
                              <DocumentosHse documentos={c.documentos} />
                            </Col>
                            <Col xs={12}>
                              <div className="fw-bold mb-2">Documentos enviados</div>
                              {enviados.length ? (
                                <Table size="sm" bordered className="mb-0 align-middle text-center bg-white">
                                  <thead className="table-light">
                                    <tr>
                                      {["Documento", "Versão", "Número", "Enviado", "Emissão", "Validade", "Análise", "Analista", "Arquivo"].map((h) => (
                                        <th key={h} className="text-nowrap">{h}</th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {enviados.map((d) => (
                                      <tr key={d.id} className={d.vigente ? "" : "text-muted"}>
                                        <td>{d.tipo}</td>
                                        <td>v{d.versao}{d.vigente ? "" : " (substituída)"}</td>
                                        <td>{d.numero || "-"}</td>
                                        <td>{dataHse(d.dataEnvio)}</td>
                                        <td>{dataHse(d.dataEmissao)}</td>
                                        <td>{dataHse(d.dataValidade)}</td>
                                        <td>
                                          <StatusHse status={d.status} />
                                          {d.motivoReprovacao && <div className="small">{d.motivoReprovacao}</div>}
                                        </td>
                                        <td>{d.analista || "-"}</td>
                                        <td>
                                          <Button size="sm" variant="outline-primary" onClick={() => baixar(d)}>
                                            Baixar
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              ) : (
                                <div className="text-muted fst-italic">Nenhum documento enviado.</div>
                              )}
                            </Col>
                          </Row>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-muted fst-italic">Nenhum registro encontrado.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
};
